export enum MapTypeEnum {
  DEFAULT = '',
  DESTINATION = 'destination',
  PLACE = 'place',
  HIGHLIGHT_PLACE = 'highlight_place',
  EVENT = 'event',
  DEAL = 'deal',
  GUIDE = 'guide',
  COLLECTION = 'collection',
  PASSPORTS_LIST = 'passports_list',
}
